module.exports = __webpack_public_path__ + "img/list.19b77ec6.png";